import { ComponentStyleConfig } from '@chakra-ui/react';

export const Select: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 6,
  },
  defaultProps: {
    size: 'md',
    variant: 'ecustos',
  },
  variants: {
    ecustos: {
      field: {
        background: '#FFF',
        color: 'blackAplha',
        borderWidth: 1,
        borderRadius: 5,
        borderColor: 'gray.300',
        transitionDuration: '100ms',
        _readOnly: {
          bg: `gray.100`,
          pointerEvents: 'none',
          touchAction: 'none',
          tabIndex: '-1',
          ariaDisabled: 'true',
        },
        _focus: {
          borderColor: 'blue.300',
        },
        _invalid: {
          borderColor: 'red.500',
          background: 'red.100',
          _placeholder: {
            color: 'red.600',
          },
        },
      },
      // addon: {
      //   borderColor: '#0f9',
      // },
    },
  },
};
